export enum ConnectionRulesType {
    rules4105 = 'rules4105',
    rules4110 = 'rules4110',
    unknown = 'unknown',
}
